<template>
    <button class="btn" :class="btnClass">{{ btnName }}</button>
</template>

<script>
export default {
    props: ["btnName", "btnClass"],
};
</script>
